import * as Connector from 'shared/connectors/startConnector';
import getNews from './getNews';

const editNews = (uuid, title, text) => async dispatch => {
  try {
    await Connector.editNews(uuid, title, text);
    dispatch(getNews());
    // dispatch(success(status));
  } catch (err) {
    // dispatch(failure());
  }
};

export default editNews;
